<template>
<w-main-template>
  <w-report-tree slot="sideContent" class="lnb-nav" ref="targetTree"></w-report-tree>
  <w-main-title slot="mainTitle" :title="selectedNode.label"></w-main-title>
  <component slot="mainContent" :is="currentView" @load-tree-data="loadTree"></component>
  <!-- <component slot="mainContent" :class="{'full-wrapper': selectedNode.leaf}" :is="currentView"></component> -->
</w-main-template>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WReportTree from './components/ReportTree';
import WReportTmplView from './template';
import WReportDetailView from './report';

export default {
  name: 'WReport',
  components: {
    WMainTemplate,
    WMainTitle,
    WReportTmplView,
    WReportDetailView,
    WReportTree,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          this.changeView();
        }
      },
    },
  },
  methods: {
    changeView() {
      if (this.currentView === null || isNil(this.selectedNode.leaf)) {
        this.currentView = WReportTmplView.name;
      } else {
        this.currentView = WReportDetailView.name;
      }
    },
    loadTree(treeKey) {
      this.$refs.targetTree.loadData(treeKey);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/index.vue